export default "__VITE_ASSET__nwUGsAZ4__"